import { z } from 'zod';
import { ErrorInputSchema } from '../error.js';
import { StepFunctionTaskRequestSchema } from '../request.js';
import { PhotoReportInputSchema } from './photoReportInput.js';
export const RecordPhotoReportInputSchema = PhotoReportInputSchema.extend({
    errorResults: ErrorInputSchema,
});
export const RecordPhotoReportRequestSchema = StepFunctionTaskRequestSchema.extend({
    input: RecordPhotoReportInputSchema,
});
export const RecordPhotoReportResponseSchema = z.void();
